
var my_write_compatibility_list = function(matches) {
    var e = window.jQuery(".my-compatibility-list");
    e.html('');
    if (matches.length > 0) {
        for (var i=0; i<matches.length; i++) {
             var brand = matches[i];
             e.append(window.jQuery('<button class="my-brand-suggestion" onclick="my_check_brand(this)">'+brand+'</button>'));
        }
    }
  }

  var my_check_brand = function(e) {
    my_display_match(e.textContent);
  }

  /* Factory returning a function that converts a given string
   * tmy-o n-grams. */
  function my_nGram(n) {
    if (typeof n !== 'number' || isNaN(n) || n < 1 || n === Infinity) {
      throw new Error('`' + n + '` is not a valid argument for n-gram');
    }

    return grams;

    /* Create n-grams from a given value. */
    function grams(value) {
      var nGrams = [];
      var index;

      if (value === null || value === undefined) {
        return nGrams;
      }

      value = String(value);
      index = value.length - n + 1;

      if (index < 1) {
        return nGrams;
      }

      while (index--) {
        nGrams[index] = value.substr(index, n);
      }

      return nGrams;
    }
  }

  bigrams = my_nGram(2);

  /* Get the edit-distance according to Dice between two values. */
  function my_diceCoefficient(value, alternative) {
    var left = bigrams(String(value).toLowerCase());
    var right = bigrams(String(alternative).toLowerCase());
    var rightLength = right.length;
    var length = left.length;
    var index = -1;
    var intersections = 0;
    var rightPair;
    var leftPair;
    var offset;

    while (++index < length) {
      leftPair = left[index];
      offset = -1;

      while (++offset < rightLength) {
        rightPair = right[offset];

        if (leftPair === rightPair) {
          intersections++;

          /* Make sure this pair never matches again */
          right[offset] = '';
          break;
        }
      }
    }

    return 2 * intersections / (left.length + rightLength);
  }

  /* Suggestions, while you type, are literal: only brands that actually contain
   * what has been typed. The alternative -- ten nearest brands by similarity on
   * every keystroke -- returned ten suggestions for "zzzzqqq" too, which is
   * noise wearing the costume of help. */
  var my_get_list_of_matches = function() {
    var query = window.jQuery(".my-check-compatibility-input").val();
    query = (query || "").toLowerCase().trim();
    if (query === "") return [];
    return brands.filter(function(brand) {
      return brand.toLowerCase().indexOf(query) !== -1;
    }).sort(function(a, b) {
      /* A brand that starts with what was typed beats one that merely contains
       * it, and the shorter of two beats the longer: typing "daikin" should
       * offer Daikin before "Daikin Industries". */
      var aStarts = a.toLowerCase().indexOf(query) === 0 ? 0 : 1;
      var bStarts = b.toLowerCase().indexOf(query) === 0 ? 0 : 1;
      if (aStarts !== bStarts) return aStarts - bStarts;
      return a.length - b.length;
    }).slice(0, 10);
  }

  /* Pressing Check is the last chance to be useful, so it falls back to
   * similarity when nothing matches literally. Someone who types "Dakin" means
   * Daikin, and answering "your air conditioner is not supported" over one
   * letter loses a customer who was about to buy.
   *
   * `.slice()` before sorting because the old code sorted `brands` in place,
   * quietly reordering the list every keystroke for everything else using it. */
  var my_best_match = function() {
    var literal = my_get_list_of_matches();
    if (literal.length > 0) return literal[0];

    var query = window.jQuery(".my-check-compatibility-input").val();
    if (!query || !query.trim()) return null;
    var closest = brands.slice().sort(function(a, b) {
      return my_diceCoefficient(b, query) - my_diceCoefficient(a, query);
    })[0];
    return (closest && my_diceCoefficient(closest, query) > 0.3) ? closest : null;
  }

  var my_compatibility_click = function(){
    var matches = my_get_list_of_matches();
    window.jQuery(".my-compatibility-not-matched").hide();
    window.jQuery(".my-compatibility-results").hide();
    my_write_compatibility_list(matches);
  };

  var my_display_match = function(brand) {
    window.jQuery(".my-compatibility-results").show();
    window.jQuery(".my-compatibility-list").html('');
    var brand_searched = window.jQuery(".my-check-compatibility-input").val();
    var e = window.jQuery(".my-compatibility-results-brand");
    e.text(brand);
    if (brand_searched.toLowerCase().trim() != brand.toLowerCase()) {
      e = window.jQuery(".my-compatibility-results-did-you-mean-brand");
      e.html('<a style="color: blue;" onClick="my_display_mismatch(); return false;" href="#">'+brand_searched+'</a>?');
      window.jQuery(".my-compatibility-results-did-you-mean").show();
    } else {
      window.jQuery(".my-compatibility-results-did-you-mean").hide();
    }
    e = window.jQuery(".my-compatibility-results");
    e.show();
    window.jQuery(".my-check-compatibility-input").data("brand-searched", brand_searched);
  }

  var my_display_mismatch = function() {
    window.jQuery(".my-compatibility-list").html('');
    window.jQuery(".my-compatibility-not-matched").show();
    window.jQuery(".my-compatibility-not-matched input").focus();
  }

  var my_compatibility_check = function() {
    var best = my_best_match();
    if (best)
      my_display_match(best);
    else
      my_display_mismatch();
  };

  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  var my_send_email = function(e) {
    var email = window.jQuery('.ac-mismatch-form input[type="email"]').val();
    if (!validateEmail(email)) {
      return;
    }
    var ac_brand = window.jQuery(".my-check-compatibility-input").data("brand-searched") || window.jQuery(".my-check-compatibility-input").val();
    window.jQuery.ajax({
        type: "POST",
        url: "https://m5mcdrbng6.execute-api.eu-west-1.amazonaws.com/prod/website_email_filled",
        data: JSON.stringify({"email": email, "brand": ac_brand}),
        crossDomain: true,
        contentType: 'application/json',
        success: function() {
          window.jQuery('#my-compatibility-not-matched').html('<h4 class="success">Thank you. We will get back to you promptly.</h4>');
        },
        error: function() {
          window.jQuery('#my-compatibility-not-matched').html('<h4 class="success">Thank you. We will get back to you promptly.</h4>');
          window.jQuery('#my-compatibility-not-matched').append('<h4 class="error">There was an error in submitting the form. Please contact support@sinsibo.com</h4>');
        },
    });
    window.jQuery('#my-compatibility-not-matched').html('<h4 class="success">Thank you. We will get back to you promptly.</h4>');
  }

  var my_compatibility_focus = function() {
  }

  var my_init_compatibility_check = function() {
    window.jQuery(".my-check-compatibility-input").on('input', my_compatibility_click);
    window.jQuery(".my-check-compatibility-input").on('focus', my_compatibility_focus);
    window.jQuery("#my-check-compatibility-button").on('click', my_compatibility_check);

    window.jQuery('.ac-mismatch-form-button').on('click', my_send_email);

    window.jQuery(".my-check-compatibility-input").keyup(function(event){
      if(event.keyCode == 13){
        my_compatibility_check();
      }
    });
  }

  window.addEventListener('jQueryLoaded', function (e) {
    my_init_compatibility_check();
  });
